module.exports = __webpack_public_path__ + "img/Free-Hair-Curls-Long-Curly-Hair-Topper-IN6×6-2.6dd5e70c.jpg";